import { SkillType, VAT } from '@types';
import { z } from 'zod';

export const vatSchema = z.enum([VAT.LOW, VAT.HIGH, VAT.NONE, VAT.REVERSE]);

export const workerEmploymentTypeSchema = z.enum(['FREELANCER', 'TEMPWORKER', 'EMPLOYEE']);

export const locationSchema = z.object({
  id: z.string(),
  address: z.string(),
  latitude: z.number().nullable(),
  longitude: z.number().nullable(),
  street: z.string().nullable(),
  houseNumber: z.string().nullable(),
  postalCode: z.string().nullable(),
  country: z.string().nullable(),
  city: z.string().nullable(),
});

export const placementStatesSchema = z.enum(['active', 'canceled', 'terminated', 'completed']);

export type PlacementStates = z.infer<typeof placementStatesSchema>;

export const skillTypeSchema = z.enum([
  SkillType.SOFT_SKILL,
  SkillType.APPAREL,
  SkillType.LANGUAGE,
]);

export const keyValueSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export const breakOptionsSchema = z.object({
  id: z.string(),
  label: z.string(),
  minutes: z.number(),
});
